export const demandwordRank = {
  goodExpose: 'n.5210.7711.0', // 热卖复购榜单二级页-商品曝光
  chooseFormate: 'n.5210.96.0', // 热卖复购榜单二级页-选规格点击
  chooseFormateClose: 'n.5210.97.0', // 热卖复购榜单二级页-收起点击
  goodAdd: 'n.5210.10.0', // 热卖复购榜单二级页-加购物车点击
  goodMin: 'n.5210.11.0', // 热卖复购榜单二级页-减购物车点击
  goodGoDetail: 'n.5210.262.0', // 热卖复购榜单二级页-跳转详情点击
  clickFloatCart: 'n.5210.8970.0' // 热卖复购榜单二级页-悬浮购物车按钮点击
}
